// components/CountCards.jsx
import React, { useEffect, useState } from "react";
import { Card, Typography, useMediaQuery } from "@mui/material";
import Grid from "@mui/material/Grid";

const CountCards = ({ data, selectedTab, setSelectedTab }) => {
  const [entries, setEntries] = useState([]);

  useEffect(() => {
    if (data) {
      setEntries(Object.entries(data));
    }
  }, [data]);

  return (
    <Grid container spacing={2} padding={2}>
      {entries.map(([label, count]) => (
        <Grid item xs={3} sm={3} md={3} lg={3} key={label}>
          <Card
            elevation={3}
            sx={{
              borderRadius: 3,
              border:
                selectedTab === label ? "1px solid white" : "1px solid red",
              minHeight: 120,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "flex-start",
              bgcolor: selectedTab === label ? "red" : "background.paper",
              p: 2,
            }}
            onClick={() => {
              setSelectedTab(label);
            }}
          >
            <Typography variant="h5" fontWeight={600}>
              {count}
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.secondary"
              sx={{
                textTransform: "capitalize",
                mt: 1,
                color: selectedTab === label ? "white" : "red",
              }}
            >
              {label}
            </Typography>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default CountCards;
